import { Component, Input, OnInit } from '@angular/core';
import { AlertService, IAlertType, NotificationStoreService } from "../../../../_shared/services";
import { Notification, WebserviceResponse} from "../../../../_shared/interfaces";
import {ClrDatagridModule, ClrDatagridSortOrder} from "@clr/angular";
import {DatePipe, NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";
@Component({
  selector: 'app-job-details-notification',
  standalone: true,
  imports: [
    ClrDatagridModule,
    NgIf,
    RouterLink,
    DatePipe
  ],
  templateUrl: './job-details-notification.component.html',
  styleUrl: './job-details-notification.component.sass'
})
export class JobDetailsNotificationComponent implements OnInit {
  notification60: Notification[] = [];
  notification61: Notification[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;

  @Input() projectID!: string;
  @Input() jobID!: number;

  constructor(
    private notss: NotificationStoreService,
    private alertDispatcher: AlertService,
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.loadList60(this.projectID, 0, this.jobID);
    this.loadList61(this.projectID, this.jobID);
  }

  loadList60(projectID: string, orderID: number, jobID: number) {
    this.notss.getNotification(projectID, 0, jobID, orderID, 60).subscribe({
      next: (data: any) => {
        const response = data as WebserviceResponse<Notification[]>;
        if (!response || !response.object || response.object.length === 0) {
          this.alertDispatcher.alertConfig.message = 'Keine Notification gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.notification60 = response.object;
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      error: () => {
        return
      }
    });
  }

  loadList61(projectID: string, jobID: number) {
    this.notss.getNotification(projectID, 0, jobID, 0,61).subscribe({
      next: (data: any) => {
        const response = data as WebserviceResponse<Notification[]>;
        if (!response || !response.object || response.object.length === 0) {
          this.alertDispatcher.alertConfig.message = 'Keine Notification gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
      this.notification61 = response.object;
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      error: () => {
        return
      }
    });
  }


}
